<template>
    <div>
        <v-card flat>
          <v-card-title class="secondary white--text d-flex justify-space-between">
            <div class="d-md-flex align-start">
              <v-btn class="ml-md-3 mt-md-1" text dark @click="exportReport()">
                <v-icon small  left>mdi-export-variant</v-icon>
                <span>Export</span>
              </v-btn>
            </div>
            <TableSearch @input="(newText) => {search = newText}" />
          </v-card-title>
  
          <v-data-table
            class="tableColor"
            :loading="isLoading"
            :search="search"
            :headers="headers"
            :items="unpaidInvoices || []"
            :items-per-page="10"
            :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
          >
          <template v-slot:item.InvoiceNumber="{ item }">
              <span>
                <v-btn depressed @click="downloadInvoice(item)">{{item.InvoiceNumber}}</v-btn>
              </span>
            </template>
            <template v-slot:item.InvoicedDate="{ item }">
              <span>
                {{ item.InvoicedDate | formatDate }}
              </span>
            </template>
            <template v-slot:item.InDebtSince="{ item }">
              <span>
                {{ item.InDebtSince | formatDate }}
              </span>
            </template>
            <template v-slot:item.MainBalance="{ item }">
              <span>
                {{ toCurrencyFilter(item.MainBalance, currencyData) }}
              </span>
            </template>
            <template v-slot:item.SalesNetAmount="{ item }">
              <span>
                {{ toCurrencyFilter(item.SalesNetAmount, currencyData) }}
              </span>
            </template>
            <template v-slot:item.SalesVATAmount="{ item }">
              <span>
                {{ toCurrencyFilter(item.SalesVATAmount, currencyData) }}
              </span>
            </template>
            <template v-slot:item.SalesGrossAmount="{ item }">
              <span>
                {{ toCurrencyFilter(item.SalesGrossAmount, currencyData) }}
              </span>
            </template>
            <template v-slot:item.PaidAmountNet="{ item }">
              <span>
                {{ toCurrencyFilter(item.PaidAmountNet, currencyData) }}
              </span>
            </template>
            <template v-slot:item.PaidAmountVAT="{ item }">
              <span>
                {{ toCurrencyFilter(item.PaidAmountVAT, currencyData) }}
              </span>
            </template>
          </v-data-table>  
        </v-card>
    </div>
  </template>
  
  <script>
  import {mapGetters, mapState} from 'vuex'
  import moment from 'moment/src/moment'
  import TableSearch from '@/components/TableComponents/TableSearch.vue'
  import {toCurrencyFilter} from '@/jsFunctions/toCurrencyFilterFunction.js'
  
  export default {
    name: 'unpaidInvoicesTable',
    components: {
      TableSearch
    },
    props: {
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      search: '',
      headers: []
    }),
    methods: {
      exportReport() {
        this.$store.dispatch('UnpaidInvoices/exportUnpaidInvoices') 
      },
      downloadInvoice(item) {
      this.$store.dispatch('OutgoingPayments/downloadInvoice', {
        invoiceID: item.OID,
        filename: `${item.GlobalReference}.pdf`
      })
      .catch((error) => {
        console.error('Download failed:', error)
      })
      },
      setHeaders(vatRegistered){
        this.headers = [
          {
            text: 'Person',
            align: 'left',
            value: 'Person',
          },
          { text: 'Person Info', value: 'PersonInfo' },
          { text: 'Person Reference', value: 'PersonRef' },
          { text: 'Property', value: 'Property' },
          { text: 'Main Balance', value: 'MainBalance' },
          { text: 'Invoiced Date', value: 'InvoicedDate' },
          { text: 'Invoice Number', value: 'InvoiceNumber' },
          { text: 'SalesNetAmount', value: 'SalesNetAmount' },
          { text: 'SalesVATAmount', value: 'SalesVATAmount' },
          { text: 'SalesGrossAmount', value: 'SalesGrossAmount' },
          { text: 'PaidAmountNet', value: 'PaidAmountNet' },
          { text: 'PaidAmountVAT', value: 'PaidAmountVAT' },
        ]
          if(!vatRegistered){
          this.headers = [
          {
            text: 'Person',
            align: 'left',
            value: 'Person',
          },
          { text: 'Person Info', value: 'PersonInfo' },
          { text: 'Person Reference', value: 'PersonRef' },
          { text: 'Property', value: 'Property' },
          { text: 'Main Balance', value: 'MainBalance' },
          { text: 'Invoiced Date', value: 'InvoicedDate' },
          { text: 'Invoice Number', value: 'InvoiceNumber' },
          { text: 'SalesNetAmount', value: 'SalesNetAmount' },       
          { text: 'PaidAmountNet', value: 'PaidAmountNet' },
        ]
        }
      },
    toCurrencyFilter
    },
    computed: {
      ...mapState({
        unpaidInvoices: state => state.UnpaidInvoices.unpaidInvoices,
      }),
      ...mapGetters({
        currencyData: "CurrencyData/currencyInfo"
      }),
      computedDateFormattedMomentjs () {
        return this.date ? moment(this.date).format('MMMM YYYY') : ''
      },
    },
    created() {
      // Set default headers
      this.setHeaders(true); // Default to VAT registered headers
      // Data loading is now handled by parent component for lazy loading
    },
    watch: {
      unpaidInvoices: {
        immediate: true,
        handler(newVal) {
          if (newVal && newVal.length > 0) {
            this.setHeaders(newVal[0].IsVATRegistered);
          }
        }
      }
    }
  }
  </script>